import React from "react";
import { Table, Typography } from "antd";

const { Text } = Typography;

const columns = [
  {
    title: "Item",
    dataIndex: "item",
    key: "item",
    width: 150, 
    render: (text, record) => <Text className={record.className}>{text}</Text>,
    responsive: ["xs", "sm", "md", "lg"],
  },
  {
    title: "Original Contract Value",
    dataIndex: "original",
    key: "original",
    width: 200, 
    responsive: ["sm", "md", "lg"],
  },
  {
    title: "Current IPA",
    dataIndex: "currentIPA",
    key: "currentIPA",
    width: 150,
    responsive: ["md", "lg"],
  },
  {
    title: "Previous Submitted IPA",
    dataIndex: "previousIPA",
    key: "previousIPA",
    width: 150, 
    responsive: ["lg"],
  },
  {
    title: "IPC",
    dataIndex: "ipc",
    key: "ipc",
    width: 150,
    responsive: ["lg"],
  },
];

const rows = [
  { key: 1, item: "Reference", className: "font-bold", currentIPA: "IPA-3", previousIPA: "IPA-2", ipc: "IPA-1" },
  { key: 2, item: "Preliminary", className: "text-gray-500" },
  { key: 3, item: "Work Done", className: "text-gray-500" },
  { key: 4, item: "Provisional Sum", className: "text-gray-500" },
  { key: 5, item: "Contingency", className: "text-gray-500" },
  { key: 6, item: "Change Order", className: "text-gray-500" },
  { key: 7, item: "Variation To Contract", className: "text-gray-500" },
  { key: 8, item: "Sub-Total-A", className: "font-bold" },
  { key: 9, item: "Additional Works Under Review", className: "text-gray-500" },
  { key: 10, item: "Variations", className: "text-gray-500" },
  { key: 11, item: "Claims", className: "text-gray-500" },
  { key: 12, item: "Sub-Total-B", className: "font-bold" },
  { key: 13, item: "Forecast Contract Value", className: "font-bold" },
  { key: 14, item: "Add: Advance", className: "text-gray-500" },
  { key: 15, item: "Less: Advance", className: "text-gray-500" },
  { key: 16, item: "Add: Material-On-Site ", className: "text-gray-500" },
  { key: 17, item: "Less: Retention", className: "text-gray-500" },
  { key: 18, item: "Sub-Total-C", className: "font-bold" },
  { key: 19, item: "Net Payable Amount", className: "font-bold" },
  { key: 20, item: "VAT @ 5%", className: "text-gray-500" },
  { key: 21, item: "Gross Payable Amount", className: "font-bold" },
  { key: 22, item: "Amount Received", className: "text-gray-500" },
  { key: 23, item: "Balance to Receive", className: "text-gray-500" },
];

const ContractSummaryTable = () => {
  return (
    <div className="p-4 md:p-6 min-h-screen flex justify-center">
      <div className="w-full max-w-6xl"> 
        <h2 className="text-xl font-bold mb-4 text-center">Contract Summary</h2>
        <Table
          columns={columns}
          dataSource={rows}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }} 
          className="bg-white shadow-lg rounded-lg"
        />
      </div>
    </div>
  );
};

export default ContractSummaryTable;